import * as React from 'react';
import { SPaymentMethodIcon } from './style';
import { paymentMethodRegex } from '../../helpers/common';

export interface ICreditCardIconProps {
  value: string;
  detect?: boolean;
  input?: boolean;
}

const CreditCardIcon: React.FC<ICreditCardIconProps> = ({ value, detect = true, input = false }) => {
  const [paymentMethodType, setPaymentMethodType] = React.useState(null);

  React.useEffect(() => {
    if (detect) {
      // Add a case where credit card value inserted with rifm
      if (value.includes('-')) {
        value = value.replace(/-/g, '');
      }
      const paymentMethod = detectPaymentMethod(Number(value));
      if (paymentMethod) {
        setPaymentMethodType(paymentMethod);
      } else if (paymentMethodType) {
        setPaymentMethodType(null);
      }
    }
  }, [value]);

  const detectPaymentMethod = (value: number) => {
    return Object.keys(paymentMethodRegex).find((key) => paymentMethodRegex[key].test(value));
  };

  return <SPaymentMethodIcon input={input} paymentMethodType={paymentMethodType}></SPaymentMethodIcon>;
};

export default CreditCardIcon;
